import React, { FunctionComponent } from 'react';

interface TextProps {
    as: 'h1' | 'h2' | 'h3' | 'p';
}
export const Text: FunctionComponent<TextProps> = (props) => {
    const { as: Component, children } = props;
    return <Component>{children}</Component>;
};
